import { useQuery } from "@tanstack/react-query";
import { CountryCode } from "@vygruppen/vy-train-map";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import { InternalMessageResponse } from "features/CenterContent/RoleContent/InternalMessage/schema/responseSchema";
import { TrainTab } from "features/CenterContent/shared/Tabs/useTabsContext";
import { useParams } from "react-router-dom";

export const TrainInternalMessagesQueryKey = (
  trainDate: string | undefined,
  trainNumber: string | undefined,
  countryCode: CountryCode | undefined,
) => ["trainInternalMessage", countryCode, trainNumber, trainDate];

export const useTrainInternalMessage = () => {
  const { trainNumber, trainDate, countryCode } =
    useParams<Partial<TrainTab>>();

  const queryKey = TrainInternalMessagesQueryKey(
    trainDate,
    trainNumber,
    countryCode,
  );

  const { data, status } = useQuery({
    queryKey,
    refetchInterval: 60000,
    queryFn: ({ signal }) =>
      queryFnGET<InternalMessageResponse[]>({
        signal,
        url: `${getBackendUrl()}/global-information/internal-info/train/${countryCode}/${trainDate}/${trainNumber}`,
      }),
    refetchOnWindowFocus: true,
  });

  return {
    data,
    status,
  };
};
